import { api, handleApiCall, ApiResult } from './api';
import { 
  HomeExpenseGroupCategoryDto, 
  CreateHomeExpenseGroupCategoryCommand, 
  UpdateHomeExpenseGroupCategoryCommand 
} from '../types/homeExpenses';

// Get all categories
export const getCategories = async (): Promise<HomeExpenseGroupCategoryDto[]> => {
  return handleApiCall(() => 
    api.get<ApiResult<HomeExpenseGroupCategoryDto[]>>('/api/HomeExpenseGroupCategories')
  );
};

// Get category by ID
export const getCategoryById = async (publicId: string): Promise<HomeExpenseGroupCategoryDto> => {
  return handleApiCall(() => 
    api.get<ApiResult<HomeExpenseGroupCategoryDto>>(`/api/HomeExpenseGroupCategories/${publicId}`)
  );
};

// Create category
export const createCategory = async (category: CreateHomeExpenseGroupCategoryCommand): Promise<HomeExpenseGroupCategoryDto> => {
  return handleApiCall(() => 
    api.post<ApiResult<HomeExpenseGroupCategoryDto>>('/api/HomeExpenseGroupCategories', category)
  );
};

// Update category
export const updateCategory = async (publicId: string, category: UpdateHomeExpenseGroupCategoryCommand): Promise<HomeExpenseGroupCategoryDto> => {
  return handleApiCall(() => 
    api.put<ApiResult<HomeExpenseGroupCategoryDto>>(`/api/HomeExpenseGroupCategories/${publicId}`, category)
  );
};

// Delete category
export const deleteCategory = async (publicId: string): Promise<void> => {
  return handleApiCall(() => 
    api.delete<ApiResult<boolean>>(`/api/HomeExpenseGroupCategories/${publicId}`)
  );
};
